import React from 'react'
import { Button } from "@material-ui/core"
import moment from "moment"
class ButtonCalendar extends React.PureComponent{
  constructor(props){
    super(props)
    this.onClick=this.onClick.bind(this)
  }

  onClick(evt){
    this.props.onClick&&this.props.onClick(evt)
    this.props.onPress&&this.props.onPress(evt)
  }

  formatLabel(from, to, period, useWeek){
    if(!from||period=='custom'&&!to){
      return "Seleccione una fecha"
    }
    if(useWeek&&period=="weekly"){
      console.log("FRMATO SEMANAL", moment(from).format("DD/MM/YYYY"), moment(from).format("[Semana] ww/YYYY"), moment(from).format("[Semana] WW/YYYY"))
      return moment(from).format("[Semana] ww/YYYY"); 
    }
    switch(period){
      case "dayly": return moment(from).format("DD/MM/YYYY")
      case "weekly": return `${moment(from).format("DD/MM/YYYY")} - ${moment(to).format("DD/MM/YYYY")}`
      case "monthly": return moment(from).format("MM/YYYY")
      default: return `${moment(from).format("DD/MM/YYYY")} - ${moment(to).format("DD/MM/YYYY")}`
    }
  }

  render(){
    const {value, onClick, label, from, to, period, onPress, useWeek} = this.props
    return (
      <text onClick={this.onClick}>
        {this.formatLabel(from, to, period, useWeek)}
      </text>
      // <Button onClick={onClick}>
      //   {label}
      // </Button>
    )
  }
}

export default ButtonCalendar


// WEBPACK FOOTER //
// ./src/components/ButtonCalendar/ButtonCalendar.js